import { isEqual, mapValues } from 'lodash';

import { log } from './logger';

const MINUTE_MS = 30000;

export const getParams = (content, youtubeParameters, tweetParameters) => {
  mapValues(content, (newContent) => {
    let firstIndex = true;
    let youtubeVideoCount = 0;
    let sectionYoutubeParam = null;

    let firstIndexTweet = false;
    let tweetCount = 0;
    let sectionTweetParam = null;

    mapValues(newContent?.content, (content) => {
      mapValues(content?.widget?.content, (widgetContent) => {
        // store only the twitter and youtube parameters of the first
        // element because in the same page all twitter or youtube parameters should be the same

        if (widgetContent?.__typename === 'CmsPortalComponentWidgetTwitter') {
          if (!firstIndexTweet) {
            sectionTweetParam = {};
            if (widgetContent.screenName) {
              sectionTweetParam.screenName = widgetContent.screenName;
            }
            if (widgetContent.hashtags) {
              sectionTweetParam.hashtags = widgetContent.hashtags;
            }

            firstIndexTweet = true;
          }
          tweetCount++;
        }
        if (
          widgetContent?.__typename === 'CmsPortalComponentWidgetYoutubeStream'
        ) {
          if (firstIndex) {
            sectionYoutubeParam = {};
            firstIndex = false;
            if (widgetContent.screenName) {
              sectionYoutubeParam.screenName = widgetContent.screenName;
            }
            if (widgetContent.playlists) {
              sectionYoutubeParam.playlist = widgetContent.playlists;
            }
            if (widgetContent.orderBy) {
              sectionYoutubeParam.orderByPosition =
                widgetContent?.orderBy === 'POSITION_IN_PLAYLIST';
            }
          }
          youtubeVideoCount++;
        }
      });
    });

    if (sectionYoutubeParam) {
      sectionYoutubeParam.count = youtubeVideoCount;
    }
    if (sectionTweetParam) {
      sectionTweetParam.count = tweetCount;
    }
    youtubeParameters.push(sectionYoutubeParam);
    tweetParameters.push(sectionTweetParam);
  });
};

export const fetch = async (parameters, setter, fetch) => {
  try {
    const promise = await Promise.all(
      parameters.map(async (params) => {
        if (params) {
          try {
            const result = await fetch(params, params.count);
            return Promise.resolve(result?.data);
          } catch (error) {
            console.error('error', error);
            throw error;
          }
        }
      })
    );
    setter((item) => (!isEqual(item, promise) ? promise : item));
  } catch (error) {
    log(error);
  }
};

export const getFetchingInterval = (parameters, setter, getApi) => {
  let interval = null;
  if (parameters.length > 0) {
    fetch(parameters, setter, getApi);
    interval = setInterval(() => {
      fetch(parameters, setter, getApi);
    }, MINUTE_MS);
  }
  return interval;
};
